import React, { useState, useEffect } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import MenuIcon from '../../assets/burger-menu-icon.svg';

function BurguerMenu() {
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    setOpenMenu(false);
  }, [openMenu]);

  return (
    <Menu width="80vw" right isOpen={openMenu} pageWrapId="page-wrap" customBurgerIcon={<img src={MenuIcon} alt="Abrir o menu" />}>
      <Link to="/" className="nav-link" onClick={() => setOpenMenu(true)}> Início </Link>
      <a href="http://www.amorc.org.br" target="_blank" rel="noopener noreferrer" className="nav-link" onClick={() => setOpenMenu(false)}>Portal</a>
      <Link
        to={{
          pathname: '/oa',
          state: {
            name: '', type: '', date: '', activity: '',
          },
        }}
        className="nav-link"
        onClick={() => setOpenMenu(true)}
      >
                Pesquisar Atividade

      </Link>
    </Menu>
  );
}


export default BurguerMenu;
